import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import RegistrationPage from "@/pages/RegistrationPage";
import ContractPage from "@/pages/ContractPage";
import ConfirmationPage from "@/pages/ConfirmationPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboard from "@/pages/AdminDashboard";
import NonEnrolledSessionPicker from "@/pages/NonEnrolledSessionPicker";
import NonEnrolledRegistration from "@/pages/NonEnrolledRegistration";
import NonEnrolledContract from "@/pages/NonEnrolledContract";
import NonEnrolledConfirmation from "@/pages/NonEnrolledConfirmation";
import NonEnrolledAdmin from "@/pages/NonEnrolledAdmin";
import HalfSeasonSignup from "@/pages/HalfSeasonSignup";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/register" element={<RegistrationPage />} />
          <Route path="/contract/:registrationId" element={<ContractPage />} />
          <Route path="/confirmation/:registrationId" element={<ConfirmationPage />} />
          <Route path="/non-enrolled" element={<NonEnrolledSessionPicker />} />
          <Route path="/non-enrolled/register" element={<NonEnrolledRegistration />} />
          <Route path="/non-enrolled/contract/:registrationId" element={<NonEnrolledContract />} />
          <Route path="/non-enrolled/confirmation/:registrationId" element={<NonEnrolledConfirmation />} />
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/non-enrolled" element={<NonEnrolledAdmin />} />
          <Route path="/half-season/:token" element={<HalfSeasonSignup />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
